<template>
  <generic-modal
    v-bind="$props"
    confirm-color="error"
    :confirm-text="`delete ${item}`"
    :value="value"
    :title="`Delete ${category}`"
    persistent
    :hide-louis="hideLouis"
    v-on="$listeners"
  >
    Are you sure that you want to
    <span class="red--text font-weight-bold"> DELETE {{ item }}? </span>This cannot be undone.
    <slot />
  </generic-modal>
</template>

<script>
import GenericModal from '@/components/modals/generic-modal'

export default {
  name: 'DeleteModal',
  components: {
    GenericModal,
  },
  props: {
    category: {
      type: String,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: String,
      default: undefined,
    },
    value: {
      type: Boolean,
      default: false,
    },
    hideLouis: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
